import classNames from "clsx";

export const SummaryDivider = () => {
  return <div className={classNames("my-3", "border-b", "border-border-action", "px-2")} />;
};
